export default __webpack_public_path__ + "static/media/Edi si A la apartament_24-min.780d5237.jpg";